var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{attrs:{"id":"wx-qrimg"}},[_c('div',{staticClass:"qr-name"},[_vm._v("扫一扫 欢迎关注")]),_c('img',{attrs:{"src":_vm.wx}}),_c('div',{staticClass:"qr-name-welcome"},[_vm._v("中国老教授协会 微信公众号")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }